<template>
  <div>
    <div class="containerFull" style="min-height:600px">
      <div class="p-grid">
        <div class="p-col-12">
          <h2 style="border-bottom: 1px solid #cfcfcf;" class="p-pb-5 p-mt-6 titulo-admin p-ml-2">
            Listado de Cotizaciones
          </h2>
          <DataTable
            ref="dt"
            :value="itemsList"
            dataKey="id"
            :paginator="true"
            :rows="rowsPerPage"
            :lazy="true"
            :totalRecords="totalRecords"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 25, 50]"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} cotizaciones"
            class="p-datatable-responsive-demo p-mt-5"
            style="margin-bottom:100px"
            :loading="loading"
            @page="onPage"
            @sort="onSort"
          >
            <template #header>
              <div
                class="table-header"
                style="align-items: center;display: flex;"
              >
                <span class="p-input-icon-left" style="margin-left: auto;">
                  <i class="pi pi-search" />
                  <InputText
                    v-model="searchText"
                    placeholder="Buscar por nombre o código..."
                    @input="onSearch"
                  />
                </span>
              </div>
            </template>
            <Column field="fecha_hora" header="Fecha" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Fecha</span>
                {{ formatDateTime(slotProps.data.fecha_hora) }}
              </template>
            </Column>
            <Column field="nombres" header="Nombres" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Nombres</span>
                {{ slotProps.data.nombres }}
              </template>
            </Column>
            <Column field="apellidos" header="Apellidos" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Apellidos</span>
                {{ slotProps.data.apellidos }}
              </template>
            </Column>
            <Column field="codigo_cotizacion" header="Código" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Código</span>
                {{ slotProps.data.codigo_cotizacion }}
              </template>
            </Column>
            <Column field="precio" header="Precio" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Precio</span>
                {{ formatNumber(slotProps.data.precio) }}
              </template>
            </Column>
            <Column field="tiempo" header="Tiempo (min)" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Tiempo (min)</span>
                {{ slotProps.data.tiempo }}
              </template>
            </Column>
            <Column field="tipo_anestesia" header="Anestesia" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Anestesia</span>
                {{ slotProps.data.tipo_anestesia == 0 ? "general" : "local" }}
              </template>
            </Column>            
            <Column :exportable="false">
              <template #body="slotProps">
                <span class="p-column-title">Acciones</span>
                <BotonDescargaCotizacion :id="slotProps.data.id" size="small" />
                <Button
                  icon="mdi mdi-account-details-outline"
                  class="p-button-rounded p-button-success p-mr-2"
                  @click="editItem(slotProps.data)"
                  v-tooltip.top="'Ver detalle'"
                  name="ver_detalle"
                />
                <Button
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDeleteItem(slotProps.data)"
                  v-tooltip.top="'Eliminar'"
                  name="eliminar"
                />
              </template>
            </Column>
          </DataTable>
          <Dialog
            :closable="false"
            :visible="itemDialog"
            :style="{ width: '450px' }"
            header="Detalles de la Cotización"
            :modal="true"
            class="p-fluid"
            :contentStyle="{ overflow: 'visible' }"
          >
            <div class="p-grid">
              <div class="p-col-12">
                <p><strong>Código:</strong> {{ item.codigo_cotizacion }}</p>
              </div>
              <div class="p-col-12">
                <p><strong>Solicitante:</strong> {{ item.nombres }} {{ item.apellidos }}</p>
              </div>
              <div class="p-col-12">
                <p><strong>Fecha y Hora:</strong> {{ formatDateTime(item.fecha_hora) }}</p>
              </div>
              <div class="p-col-12">
                <p><strong>Duración:</strong> {{ item.tiempo }} minutos</p>
              </div>
              <div class="p-col-12">
                <p><strong>Monto (COP):</strong> {{ formatNumber(item.precio) }}</p>
              </div>
              <div class="p-col-12">
                <p><strong>Monto con descuento (COP):</strong> {{ formatNumber(item.precio*item.porcentaje_descuento) }}</p>
              </div>
              <div class="p-col-12">
                <p><strong>Anestesia:</strong> {{ item.tipo_anestesia == 0 ? "general" : "local" }}</p>
              </div>
              <div class="p-col-12">
                <p><strong>Cirugias:</strong></p>
                <ul>
                  <li v-for="(cirugia, index) in item.cirugias" :key="index">
                    {{ cirugia.nombre }}
                  </li>
                </ul>
              </div>
              <div class="p-col-12">
                <p><strong>Paciente:</strong></p>
                <ul v-for="(paciente, index) in item.pacientes" :key="index">                  
                  <li><strong>Identificación:</strong> {{ paciente.tipo_identificacion }} - {{ paciente.identificacion }}</li>
                  <li><strong>Nombre:</strong> {{ paciente.nombres }} {{ paciente.apellidos }}</li>
                </ul>
              </div>
            </div>
            <template #footer>
              <Button
                label="Cerrar"
                icon="pi pi-times"
                class="p-button-text"
                @click="hideDialog"
                name="cerrar"
              />
            </template>
          </Dialog>
          <Dialog
            :visible="deleteItemDialog"
            :style="{ width: '450px' }"
            header="Confirmación de eliminación"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="item"
                >¿Esta seguro que desea eliminar la cotización seleccionada?</span
              >
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteItemDialog = false"
                name="cancelar"
              />
              <Button
                label="Si"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteItemSelected"
                name="aceptar"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CotizacionesService from "../service/cotizaciones.service";
import BotonDescargaCotizacion from "./boton_descarga_cotizacion.vue";
export default {
  metaInfo: {
    title: 'Backoffice - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Backoffice - QualityCare',
        content: 'Administración del sitio web',
      },
    ],
  },
  name: "CotizacionesAdmin",
  components: {
    BotonDescargaCotizacion,
  },
  data() {
    return {
      cotizacionesService: null,
      searchText: '',
      searchTimer: null,
      item: {},
      itemsList: [],
      totalRecords: 0,
      currentPage: 1,
      rowsPerPage: 10,
      sortField: 'fecha_hora',
      sortOrder: -1,
      itemDialog: false,
      deleteItemDialog: false,
      submitted: false,
      loading: false,
      tipos_estado: [
        { name: "Inactiva", value: 0 },
        { name: "Activa", value: 1 },
      ],
    };
  },
  created() {
    this.cotizacionesService = new CotizacionesService();
  },
  mounted() {
    this.recuperarItemsForList();
  },
  methods: {
    recuperarItemsForList(page = 1, limit = this.rowsPerPage, search = this.searchText) {
      this.loading = true;
      this.cotizacionesService
        .allCotizaciones(page, limit, search, this.sortField, this.sortOrder)
        .then((result) => {
          this.itemsList = result.data.data || [];
          this.totalRecords = result.data.total || 0;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al cargar los datos",
            life: 3000,
          });
          this.loading = false;
        });
    },
    onPage(event) {
      this.currentPage = event.page + 1;
      this.rowsPerPage = event.rows;
      this.recuperarItemsForList(this.currentPage, this.rowsPerPage);
    },
    onSort(event) {
      this.sortField = event.sortField;
      this.sortOrder = event.sortOrder;
      this.currentPage = 1;
      this.recuperarItemsForList(1, this.rowsPerPage);
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.recuperarItemsForList(1, this.rowsPerPage);
      }, 400);
    },
    hideDialog() {
      this.itemDialog = false;
      this.submitted = false;
    },    
    editItem(item) {
      this.item = { ...item };
      this.itemDialog = true;
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.itemsList.length; i++) {
        if (this.itemsList[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    confirmDeleteItem(item) {
      this.item = item;
      this.deleteItemDialog = true;
    },
    deleteItemSelected() {
      this.cotizacionesService
        .eliminarPorAdmin(this.item.id)
        .then(() => {
          this.itemsList = this.itemsList.filter(
            (val) => val.id !== this.item.id
          );
          this.deleteItemDialog = false;
          this.item = {};
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Item eliminado",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatNumber(numero) {
      return new Intl.NumberFormat("de-DE").format(numero);
    },
    formatDateTime(fecha) {
      const fechaDate = new Date(fecha);
      return this.$moment(fechaDate).format("DD-MM-YYYY HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
.tituloUsuarios {
  font-size: 28px;
  font-weight: 400;
  margin-right: 50px;
}
.muyLargo {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 40em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
        }
      }
    }
  }
}
</style>
